import { render, staticRenderFns } from "./ActiveProject.vue?vue&type=template&id=311b8710"
import script from "./ActiveProject.vue?vue&type=script&lang=js"
export * from "./ActiveProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports